import { createContext } from 'react'

interface CurrentUserPermissionsType {
  hasRootAdminPermission?: boolean
  hasDomainAdminPermission?: boolean
  hasRootUserPermission?: boolean
}

const initialCurrentUserPermissionsContext: CurrentUserPermissionsType = {
  hasRootAdminPermission: false,
  hasDomainAdminPermission: false,
  hasRootUserPermission: false,
}

export const CurrentUserPermissionsContext =
  createContext<CurrentUserPermissionsType>(
    initialCurrentUserPermissionsContext
  )
